import { render, staticRenderFns } from "./exam-record.vue?vue&type=template&id=0f14ffe6&scoped=true&"
import script from "./exam-record.vue?vue&type=script&lang=js&"
export * from "./exam-record.vue?vue&type=script&lang=js&"
import style0 from "./exam-record.vue?vue&type=style&index=0&id=0f14ffe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f14ffe6",
  null
  
)

export default component.exports